
































import { Component, Prop, Vue } from "vue-property-decorator";
import { Company, Product, Brand } from "@/models";
import EntrySearch, { EntrySearchResult } from "@/components/EntrySearch.vue";
import EntryListGroup from "@/components/EntryListGroup.vue";

const DEFAULT_PLACEHOLDER = "Seleziona aziende/brand/prodotti";

@Component({
  components: {
    EntrySearch,
    EntryListGroup,
  },
})
export default class EntrySelect extends Vue {
  @Prop() readonly value!: Company | Brand | Product | null;
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder?: string;

  @Prop({ default: true }) readonly companiesEnabled?: boolean;
  @Prop({ default: true }) readonly brandsEnabled?: boolean;
  @Prop({ default: true }) readonly productsEnabled?: boolean;

  items: {
    companies: Company[];
    brands: Brand[];
    products: Product[];
  } = {
    companies: [],
    brands: [],
    products: [],
  };

  visible = false;
  selected: Company | Brand | Product | null = null;

  get label(): string {
    if (this.selected == null) {
      return this.placeholder || DEFAULT_PLACEHOLDER;
    }

    return this.selected.name;
  }

  created() {
    if (this.value) {
      this.selected = this.value.clone();
    }
  }

  toggleDropdown() {
    this.visible = !this.visible;

    if (this.visible) {
      this.$nextTick(() => {
        (this.$refs.search as EntrySearch).focus();
      });
    }
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
    }
  }

  onSearched(result: EntrySearchResult) {
    this.items.companies = result.companies;
    this.items.brands = result.brands;
    this.items.products = result.products;
    this.visible = true;
  }

  onSelected(value: Company | Brand | Product) {
    this.selected = value;
    this.$emit("input", value.clone());
    this.closeDropdown();
  }
}
